import { Component } from '@angular/core';

@Component({
  selector: 'app-aibi',
  templateUrl: './aibi.component.html',
  styleUrls: ['./aibi.component.scss']
})
export class AibiComponent {

}
